import { render, staticRenderFns } from "./admin.users.vue?vue&type=template&id=470a1a98&"
import script from "./admin.users.vue?vue&type=script&lang=js&"
export * from "./admin.users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports